export default __webpack_public_path__ + "static/media/photo3.5c493038.jpg";